(function () {
  'use strict';

  var module = angular.module('uwAgenda.website.privacypolicy', [
    'uwAgenda.help',
    'uwAgenda.global',
    'angularFileUpload'
  ]);

  module.config(['$stateProvider', PrivacyPolicyConfig]);

  function PrivacyPolicyConfig($stateProvider) {
    $stateProvider.state('Home.PrivacyPolicy', {
      url: 'privacy-policy',
      templateUrl: '/app/website-generator/privacy-policy/templates/privacy-policy.html',
      controller: 'PrivacyPolicyController',
      controllerAs: 'vm',
      data: {
        requiresLogin: true
      },
      ncyBreadcrumb: {
        label: "{{'privacy_policy' | translate}}"
      }
    });
  }
})();

